
import axios from 'axios';
import { Component, Mixins, Watch } from 'vue-property-decorator';
import PageName from '../core/components/PageName.vue';
import { ItemInfo } from '../typescript/itemInfo';
import LoadingIndicator from '../core/components/Generics/LoadingIndicator.vue';
import { ItemServices } from '../core/api/ItemServices';
import ItemIndicators from './components/ItemIndicators.vue';
import Vue from 'vue'
import ItemMap from './components/ItemMap.vue';
import Button from '../core/components/Generics/Button.vue';
import { FeatureCollection, MultiPolygon } from '../typescript/MapShapes';
import { SummaryIndicators } from '../typescript/indicators';
import { splitMultiPolygonToFeatures } from '../../features/core/utils/map-utils';
import { defaultUserPrivilege, PrivilegeValue, PRIVILEGE_KEYS } from '../../privileges/privileges';
import { parseFloatNumber } from '../../features/core/utils/date-handlers';

@Component({
    components: {
        PageName,
        LoadingIndicator,
        ItemIndicators,
        ItemMap,
        Button
    }
})
export default class PageItemDetail extends Vue {
    pendingInfo: boolean = true;
    itemInfo: ItemInfo | null = null;
    indicators: SummaryIndicators | null = null;
    errorDetail: boolean = false;
    polygonsArea: string = '-';
    diffPolygonsArea: number = 0;
    snackbarMessage: string = '';
    showSnackbar: boolean = false;
    snackbarColor: string = 'info';
    redirectUrl: string = '';
    userPrivilege: PrivilegeValue = defaultUserPrivilege;

    get isReadOnly(): boolean {
        return this.userPrivilege === PRIVILEGE_KEYS.READ_ONLY;
    }
    
    updateAreaIndicator(response){
        let polygonArea = response.calculated_area.toFixed(2);
        let diffArea = response.area_diff_percent.toFixed(2);

        let area = `${polygonArea}`;
        if(response && response.area_diff_percent){
            area += ` - Dif. (${diffArea}%)`;
        }
        this.diffPolygonsArea = diffArea;
        this.polygonsArea = area;
    }


    showAlert(message: string, color: string) {
        this.snackbarMessage = message;
        this.showSnackbar = true;
        this.snackbarColor = color

    }

    leaveItem(){
        let haveUrl = this.redirectUrl !== '';
        let self = this;
        if(haveUrl) {
            setTimeout(() => {
                window.location.href = self.redirectUrl;
            }, 1300);
        
            setTimeout(() => {
                window.open('', '_self'); 
                window.close();     
            }, 500);
        }
    }
  

    created(){
        this.getItemInfo()
    }

    getItemId(){
        return Number(this.$route.params.id)
    }



    getItemInfo(){
        this.errorDetail = false;
        this.pendingInfo = false;
        localStorage.removeItem('department_polygon');
        ItemServices.getItemDetail(
            this.getItemId(),
        ).then((response: ItemInfo) => {
            let itemPolygon:FeatureCollection | null = response && response['polygon'] as FeatureCollection | null;
            this.userPrivilege = response.privilege;
            this.redirectUrl = response.redirect_url;
            
            if(itemPolygon !== null){
                //el backend envia una unica feature con todos los poligonos,
                //por lo que hay que dividirlo en multiples features para que al eliminar una feature no se eliminen todos los poligonos
                response.polygon = splitMultiPolygonToFeatures(itemPolygon);
            }
            this.itemInfo = response;
            this.saveDepartmentLimitsPolygon();
            this.setIndicators(response);
        }).catch((error) => {
        this.errorDetail = true
        this.itemInfo = null 
        }).finally(() => {
            this.pendingInfo = false
            
        })
    }

    async saveDepartmentLimitsPolygon(){
       let departmentPolygon: null | MultiPolygon = null;

       if(this.itemInfo && this.itemInfo.department_polygon){
        departmentPolygon = this.itemInfo.department_polygon;
           await localStorage.setItem('department_polygon', JSON.stringify(departmentPolygon));
       }

    }

    async setCityLimitsQuery(){
        let query = '';
        let department = '';
        let province = '';
        await localStorage.removeItem('item_limits_query');

        if(this.itemInfo){
            department = this.itemInfo.department;
            province = this.itemInfo.province;
        }

        if(department === '' || province === '') return

        
        query = `${department} Department, ${province} Province, Argentina`;
        await localStorage.setItem('item_limits_query', query);
    }

    setIndicators(itemData: ItemInfo){
        const summaryData: SummaryIndicators = {
            crop_type: itemData.crop_type,
            declared_area: parseFloatNumber(itemData.declared_area, 1),
            department: itemData.department,
            province: itemData.province,
            campaign: itemData.campaign
        };
        this.indicators = summaryData;
    }

   

}
